module.exports = __webpack_public_path__ + "assets/img/ISO.eb6aa5bc.png";